import React, { useEffect, useState, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SearchWithAPI from "../searchbox/searchbox";
import { ReactComponent as ReportIcon } from "../../assets/svg/reportssvg.svg";
import DatePicker from "react-datepicker";
import axios from "axios";
import calendar from "../../assets/svg/MonthlyReport.svg";
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";
import { Container, Toast, ToastContainer } from "react-bootstrap";
import { getCookie } from "../getcookie.js";
import { format } from "date-fns";
import { useGlobal } from "../../GlobalContext.js";

const QuickReport = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

  const [selected, setSelected] = useState("quick");

  //Snackbar
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);

  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [showSnackbar, setShowSnackbar] = useState(false);

  //Report API
  const { selectedMenu, setSelectedMenu } = useGlobal();

  const [reportOptions, setreportOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    setSelectedMenu("Report");
    console.log({ selectedMenu })
  }, []);
  const handlequickChange = (option) => {
    exportQuickGet(option);
  };

  useEffect(() => {
    getquickreport();
  }, []);

  const getquickreport = async () => {
    const header = {
      "Content-Type": "application/json; charset=UTF-8",
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*", // Required for CORS support
      Authorization: getCookie("mawalog"),
    };

    try {
      const response = await axios.get(apiUrl + `report/get_quick_report`, { headers: header });
      console.log("API response:", response.data);

      if (response.data && response.data.success === true) {
        setreportOptions(response.data.suggestionlist);
        console.log("successful");
      } else {
        console.warn("Unexpected response or success flag missing:", response.data);
      }
    } catch (error) {
      console.error("Error in getquickreport:", error);
    }
  };

  const getIconByLabel = (label) => {
    switch (label) {
      case "daily-report":
      case "monthly_report":
      case "weekly_report":
        return calendar;
      // case "Location Based":
      //   return LocationBased;
      // case "Company Based":
      //   return CompanyBased;
      // case "Office Based":
      //   return OfficeBased;
      // case "Room Based":
      //   return RoomBased;
      // case "Upcoming Meeting":
      //   return UpcomingMeeting;
      // case "Past Meeting":
      //   return PastMeeting;
      default:
        return calendar;
    }
  };

  const exportQuickGet = async (option) => {
    console.log(option.label);
    try {
      const response = await axios
        .post(
          apiUrl + "report/" + option.value,
          {
            from_date: formattedFromDate,
            to_date: formattedToDate,
          },
          {
            headers: {
              "Content-Type": "application/json; charset=UTF-8",
              Accept: "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: getCookie("mawalog"),
            },
          }
        )
        .catch((error) => {
          console.log("error...", error.response);
          return error.response;
        });

      setSnackbarMessage(response.data.message ?? '');
      setSnackbarStatus(response.data.success ?? false);
      handleSnackbarShow();


      if (response.status === 200 && response.data.success === true) {
        console.log("inside success");
        const base64String = response.data.base64;
        const fileName = response.data.file_name;
        downloadBase64File(base64String, fileName);

      }
    } catch (err) {
      console.error("Error fetching report:", err);
    }
  };

  const downloadBase64File = (base64String, fileName) => {
    // Create headers
    const header = {
      "Content-Type": "application/json; charset=UTF-8",
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*", // Required for CORS support
      Authorization: getCookie("mawalog"),
    };

    // Convert base64 string to binary array
    const binary = atob(base64String);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }

    // Create blob from binary data
    const blob = new Blob([new Uint8Array(array)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create link and trigger download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Return headers in case needed
    return header;
  };

  //Room Dropdown
  const [roomOption, setRoomOption] = useState(null);
  const [roomSearchUrl, setRoomSearchUrl] = useState("");
  const handleRoomDropdownChange = (option) => {
    setRoomOption(option);
  };

  //Office Dropdown
  const [officeOption, setOfficeOption] = useState(null);
  const [floorOption, setFloorOption] = useState(null);
  const [floorSearchUrl, setFloorSearchUrl] = useState("");

  const handleLocationDropdownChange = (option) => {
    console.log(option);
    setOfficeOption(option);
    setFloorOption(null);
    setRoomOption(null);
    setFloorSearchUrl(apiUrl + "get_floors/" + option.value);
    setRoomSearchUrl(apiUrl + "get_room?office_id=" + option.value + "&floor_no=");
  };

  //Floor Dropdown

  const handleFloorDropdownChange = (option) => {
    setFloorOption(option);
    setRoomOption(null);
    setRoomSearchUrl(apiUrl + "get_room?office_id=" + officeOption.value + "&floor_no=" + option.value);
  };

  //Employee Dropdown

  const [employeeOption, setEmployeeOption] = useState(null);

  const handleEmployeeDropdownChange = (option) => {
    setEmployeeOption(option);
  };

  //From Date & To Date

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  //Date Picker
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [formattedFromDate, setFormattedFromDate] = useState("");
  const [formattedToDate, setFormattedToDate] = useState("");

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    if (start) {
      const formattedStart = formatDateToYYYYMMDD(start);
      setFormattedFromDate(formattedStart);
    } else {
      setFormattedFromDate("");
    }

    if (end) {
      const formattedEnd = formatDateToYYYYMMDD(end);
      setFormattedToDate(formattedEnd);
    } else {
      setFormattedToDate("");
    }
  };

  const formatDateToYYYYMMDD = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = `${d.getMonth() + 1}`.padStart(2, "0");
    const day = `${d.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDateClear = () => {
    setStartDate(null);
    setEndDate(null);
    setFormattedFromDate("");
    setFormattedToDate("");
  };

  //Download Report
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const downloadReport = async () => {
    //  setCustomSlotErrorMessage({date:'',  from:'',  to:'',});
    try {
      const data = {
        room_id: roomOption != null ? roomOption.value : "",
        office_id: officeOption != null ? officeOption.value : "",
        floor: floorOption != null ? floorOption.value : "",
        emp_id: employeeOption != null ? employeeOption.value : "",
        from_date: fromDate,
        to_date: toDate,
      };
      const headers = {
        "Content-Type": "application/json;",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: getCookie("mawalog"),
      };
      const response = await axios
        .post(apiUrl + "report", data, { headers: headers })
        .then((response) => {
          if (response.statusCode === 400) {
          } else {
            if (response.data.success === true) {
              const base64String = response.data.base64; // Truncated for brevity
              const fileName = "Report_" + new Date().getTime() + ".xlsx";

              // Convert Base64 to Blob
              const binary = atob(base64String);
              const array = [];
              for (let i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
              }
              const blob = new Blob([new Uint8Array(array)], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });

              // Create a link and trigger download
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
            setSnackbarMessage(response.data.message);
            setSnackbarStatus(response.data.success);
            handleSnackbarShow();
          }
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 400) {
            }
            setSnackbarMessage(error.response.data.message);
            setSnackbarStatus(error.response.data.success);
            handleSnackbarShow();
          } else {
            console.error("Request failed:", error.message);
          }
        });
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="GTWalsheimTrial px-0">
      <div style={{ backgroundColor: "#f8f9fb", padding: "24px", height: "100vh" }}>
        <div style={{ borderRadius: "24px", backgroundColor: "#ffffff", padding: "40px" }}>
          <Row>
            <Col sm={0} md={0} lg={4} className="d-none d-lg-block" style={{ borderRight: "1px solid #ebebeb" }}>
              <ReportIcon style={{ width: "350px", height: "350px", marginBottom: "24px" }} />
            </Col>

            <Col sm={12} md={12} lg={8} style={{ padding: "24px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "24px", width: "100%" }}>
                <div style={{ display: "flex", width: "100%" }}>
                  <Col sm={12}>
                    <div style={{ borderRadius: "100px", padding: "8px", backgroundColor: "#f8f8f8", maxWidth: "280px", display: "flex", alignItems: "center", height: "44px" }}>
                      <div onClick={() => setSelected("quick")} style={{ borderRadius: selected === "quick" ? "100px" : "0px", padding: "10px 24px", backgroundColor: selected === "quick" ? "#842234" : "", fontWeight: selected === "quick" ? "700" : "500", fontSize: "15px", color: selected === "quick" ? "#ffffff" : "#1e1e1e", cursor: "pointer" }}>
                        Quick Report
                      </div>
                      <div onClick={() => setSelected("custom")} style={{ padding: "10px 24px", fontWeight: selected === "custom" ? "700" : "500", fontSize: "15px", color: selected === "custom" ? "#ffffff" : "#1e1e1e", backgroundColor: selected === "custom" ? "#842234" : "", cursor: "pointer", borderRadius: selected === "custom" ? "100px" : "0px" }}>
                        Customized
                      </div>
                    </div>
                  </Col>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
                  {selected === "custom" ? (
                    <>
                      <Col sm={12}>
                        <div style={{ fontWeight: "700", fontSize: "20px", color: "#212129" }}>Get your report now</div>
                      </Col>
                      <div style={{ display: "flex", alignItems: "center", gap: "24px" }}>
                        <Row style={{ width: "100%" }}>
                          <Col sm={12} md={6}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                              <div style={{ fontSize: "14px", fontWeight: "500", color: "#21272c" }}>Office</div>
                              <SearchWithAPI onDropdownChange={handleLocationDropdownChange} apiUrl={apiUrl + `get_office`} placeholder="Office" selectedValue={officeOption !== null ? officeOption.label : ""} selectedOption={officeOption} />
                            </div>
                          </Col>
                          <Col sm={12} md={6} className="mb-3 mb-md-0">
                            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                              <div style={{ fontSize: "14px", fontWeight: "500", color: "#21272c" }}>Room</div>
                              <SearchWithAPI onDropdownChange={handleRoomDropdownChange} apiUrl={roomSearchUrl} placeholder="Room" selectedValue={roomOption !== null ? roomOption.label : ""} selectedOption={roomOption} />
                            </div>
                          </Col>

                        </Row>
                      </div>

                      <div style={{ display: "flex", alignItems: "center", gap: "24px" }}>
                        <Row style={{ width: "100%" }}>
                          <Col sm={12} md={6} className="mb-3 mb-md-0">
                            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                              <div style={{ fontSize: "14px", fontWeight: "500", color: "#21272c" }}>Floor</div>
                              <SearchWithAPI onDropdownChange={handleFloorDropdownChange} apiUrl={floorSearchUrl} placeholder="Floor" selectedValue={floorOption != null ? floorOption.label : ""} selectedOption={floorOption} />
                            </div>
                          </Col>
                          <Col sm={12} md={6}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                              <div style={{ fontSize: "14px", fontWeight: "500", color: "#21272c" }}>Employee</div>
                              <SearchWithAPI onDropdownChange={handleEmployeeDropdownChange} apiUrl={adminApiUrl + `get_employee`} placeholder="Employee" selectedValue={employeeOption != null ? employeeOption.label : ""} selectedOption={employeeOption} />
                            </div>
                          </Col>
                        </Row>
                      </div>

                      <div style={{ display: "flex", alignItems: "center", gap: "24px" }}>
                        <Row style={{ width: "100%" }}>
                          <Col sm={12} md={6} className="mb-3 mb-md-0">
                            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                              <div style={{ fontSize: "14px", fontWeight: "500", color: "#21272c" }}>From Date</div>
                              <input id="from_date" type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={{ height: "40px", borderRadius: "10px", border: "0.7px solid #E5E5E5", padding: "16px" }} className="date-picker w-100" placeholder="DD-MM-YYYY" />
                            </div>
                          </Col>
                          <Col sm={12} md={6}>
                            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                              <div style={{ fontSize: "14px", fontWeight: "500", color: "#21272c" }}>To Date</div>
                              <input id="to_date" type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={{ height: "40px", borderRadius: "10px", border: "0.7px solid #E5E5E5", padding: "16px" }} className="date-picker w-100" placeholder="DD-MM-YYYY" />
                            </div>
                          </Col>
                        </Row>
                      </div>

                      <div>
                        <Col sm={12}>
                          <div style={{ display: "flex", gap: "12px", alignItems: "center", justifyContent: "end" }}>
                            <button
                              style={{ borderRadius: "100px", padding: "15px 35px", backgroundColor: "#ffffff", border: "1px solid #d4dde7", fontWeight: "700", fontSize: "16px", color: "#21272c", cursor: "pointer", minWidth: "150px" }}
                              onClick={() => {
                                setOfficeOption(null);
                                setFloorOption(null);
                                setFloorSearchUrl(null);
                                setRoomOption(null);
                                setRoomSearchUrl(null);
                                setEmployeeOption(null);
                                setFromDate("");
                                setToDate("");
                              }}>
                              Reset
                            </button>

                            <button
                              style={{ borderRadius: "100px", padding: "15px 35px", backgroundColor: "#842234", border: "1px solid #d4dde7", fontWeight: "700", fontSize: "16px", color: "#ffffff", cursor: "pointer", minWidth: "150px" }}
                              onClick={() => {
                                downloadReport();
                              }}>
                              Export
                            </button>
                          </div>
                        </Col>
                      </div>
                    </>
                  ) : selected === "quick" ? (
                    <>
                      <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
                        <Row style={{ marginBottom: "24px" }}>
                          <Col sm={12} md={6}>
                            <div style={{ fontWeight: "700", fontSize: "20px", color: "#212129" }}>Just a single click is enough!</div>
                          </Col>

                          <Col sm={12} md={6}>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "flex-end", flexWrap: "wrap" }}>
                              <div style={{ fontWeight: "500", fontSize: "14px", color: "#172b4d" }} className="d-none d-xl-block">
                                Date range :
                              </div>
                              <div>
                                <DatePicker selected={startDate} onChange={handleDateChange} startDate={startDate} endDate={endDate} selectsRange placeholderText="Select date range" className="form-control rounded-3 custom-datepicker" style={{ backgroundColor: "#F8F8F8", color: "#8790A1", cursor: "pointer" }} />
                              </div>
                              {startDate && endDate && (
                                <div style={{ cursor: "pointer" }} onClick={handleDateClear}>
                                  <SlotCloseIcon />
                                </div>
                              )}
                            </div>
                          </Col>
                        </Row>

                        <div className="container">
                          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3">
                            {reportOptions
                              .filter((item) => item.label.toLowerCase().includes(searchTerm?.toLowerCase()))
                              .map((item, index) => (
                                <div key={index} className="col">
                                  <div onClick={() => { handlequickChange(item); handleDateClear(); }} style={{ cursor: "pointer", display: "flex", gap: "12px", alignItems: "center", borderRadius: "16px", padding: "12px", border: "0.7px solid #E5E5E5", backgroundColor: "#F5F5F5", boxSizing: "border-box" }}>
                                    <div>{/* <img src={getIconByLabel(item.label)} style={{ width: "24px" }} /> */}</div>
                                    <div style={{ fontWeight: "500", fontSize: "14px", color: "#172B4D", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", flex: 1 }}>{item.label}</div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>

  );
};
export default QuickReport;
